// Prints the tick-box result sheet for the round in the Scan Results window.
//
// The layout — and the reading of it on the phone — is js/core/result-sheet.js;
// this file only supplies what needs the browser: translated labels, the QR
// images (qrcodejs, already vendored for the scan link), and the print itself.

import { buildSheetSvg, sheetPages } from '../core/result-sheet.js';

// qrcodejs draws into a canvas synchronously; the <img> it also creates is filled
// in later on some browsers, so the canvas is what gets read.
function qrDataUrl(text) {
    const host = document.createElement('div');
    new window.QRCode(host, { text, width: 296, height: 296, correctLevel: window.QRCode.CorrectLevel.M });
    const canvas = host.querySelector('canvas');
    return canvas ? canvas.toDataURL('image/png') : '';
}

/**
 * Prints one page per ROWS_PER_PAGE scorable boards. `pairings` are scan-session
 * pairings (buildScanPairings in app.js), the same list the phone reads against.
 * Returns false when there is nothing to print.
 */
export function printResultSheet({ tournamentName, groupName, token, roundNo, pairings }) {
    const printSection = document.getElementById('print-section');
    if (!printSection || !window.QRCode || !token) return false;

    const pages = sheetPages(pairings);
    if (pages.length === 0) return false;

    const labels = {
        board: tr('Board'),
        white: tr('White'),
        black: tr('Black'),
        instructions: [
            tr('Put a clear X in ONE box for each board.'),
            tr('Wrong box? Fill it in completely, then put an X in the right one.')
        ]
    };

    printSection.innerHTML = pages.map((boards, page) => {
        const subtitle = [
            groupName,
            tr('Round {n}', { n: roundNo }),
            pages.length > 1 ? tr('Sheet {page} of {pages}', { page: page + 1, pages: pages.length }) : ''
        ].filter(Boolean).join(' · ');
        // A page break after every sheet but the last, or the printer feeds a blank page.
        const breakAfter = page < pages.length - 1 ? 'break-after: page; page-break-after: always;' : '';
        return `<div style="width: 180mm; height: 265mm; overflow: hidden; ${breakAfter}">${buildSheetSvg({
            title: tournamentName,
            subtitle,
            labels,
            token,
            roundNo,
            page,
            boards,
            qrDataUrl
        })}</div>`;
    }).join('');

    window.print();
    return true;
}
